import { useState, useCallback } from 'react';
import { Info } from 'lucide-react';
import { HelpModal } from './HelpModal';
import { HELP } from '../../data/helpContent';
import type { HelpEntry } from '../../data/helpContent';

interface InfoTooltipProps {
  content: string;
  size?: number;
}

export function InfoTooltip({ content, size = 14 }: InfoTooltipProps) {
  const [show, setShow] = useState(false);

  return (
    <div className="relative inline-flex">
      <button
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        className="text-muted hover:text-secondary transition-colors"
        aria-label="More info"
      >
        <Info size={size} />
      </button>
      {show && (
        <div className="tooltip absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 pointer-events-none">
          <p className="text-xs leading-relaxed">{content}</p>
        </div>
      )}
    </div>
  );
}

interface InfoButtonProps {
  helpKey: string;
  size?: number;
}

export function InfoButton({ helpKey, size = 14 }: InfoButtonProps) {
  const [open, setOpen] = useState(false);
  const entry: HelpEntry | undefined = HELP[helpKey];
  const handleClose = useCallback(() => setOpen(false), []);

  if (!entry) return null;

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        className="inline-flex items-center justify-center text-muted hover:text-secondary transition-colors"
        aria-label={`Help: ${entry.title}`}
      >
        <Info size={size} />
      </button>
      {open && <HelpModal entry={entry} onClose={handleClose} />}
    </>
  );
}
